export default __webpack_public_path__ + "static/media/trending3.28708a3a.png";